import React, {Component} from 'react';
import axios from 'axios';
import './Register.css';
class Register extends React.Component {

  constructor(){
    super();
    this.state = {
       
    }
}
  render() {
    return <div>

<div className="row  ">


  <div className="   p-5 center-space">
    <div className="text-center">
      <a className="" href=""> <img src="/assets/images/logo/logo.jpg" alt="" title="" className="img-fluid" /> </a>
    </div>
        

    <div class="row-form  mt-5  num-left mb-2">
                        <h6  class="green-label ">Name</h6>
                        <input class="form-controls " type="text" placeholder="" id="name"/>

                        </div> 
                        <div class="row-form  num-left  mb-2">
                        <h6  class="green-label ">Mobile</h6>
                        <input class="form-controls " type="text" placeholder="" id="mobile"/>

                        </div> 
                        <div class="row-form   num-left  mb-4">
                        <h6  class="green-label ">E-mail</h6>
                        <input class="form-controls " type="text" placeholder="" id="email"/>

                        </div> 
                        <div className="text-center ">
                            <button type="button" class=" add-to-cart2 btnn ">Send OTP</button><br/>
                            <button type="button" class="  btnn  btn-outline-green">Cancel</button></div>


</div>




</div>







    </div>
    }
}

export default Register;
